import React from "react";
import Style from "../Footer.module.scss";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";

const FooterBottom = () => {
  let location = useLocation();
  const { footerData } = useSelector((state) => state.footer);
  
  return (
    <div className={Style.ftr_btm}>
      <div className={Style.btm_strip}>
        <ul>
          {footerData?.details?.menus?.[
            "footer_menu_terms_and_conditions_new"
          ]?.map((item, i) => {
            const isActive = location?.pathname === item?.url;

            return (
              <li key={i}>
                {item.class === "list-pdf" ? (
                  <a
                    href={item?.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={`${item.class} ${isActive ? Style.active : ""}`}
                  >
                    {ReactHtmlParser(item?.title)}
                  </a>
                ) : (
                  <Link to={item?.url} className={isActive ? Style.active : ""}>
                    {ReactHtmlParser(item?.title)}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      <p>{footerData?.details?.footer_more_details?.copyright}</p>
    </div>
  );
};

export default FooterBottom;
